import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

const isProduccion = environment.production;

@Injectable()
export class EnsureHttpsInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		if (isProduccion) {
			const secureReq = req.clone({
				url: req.url.replace('http://', 'https://'),
				withCredentials: true
			});
			return next.handle(secureReq);
		} else {
			return next.handle(req.clone({
				withCredentials: true
			}));
		}
	}
}
